import { render, staticRenderFns } from "./LeadsProfileDetails.vue?vue&type=template&id=53a5a708"
import script from "./LeadsProfileDetails.vue?vue&type=script&lang=js"
export * from "./LeadsProfileDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports